import React, { useState, useEffect } from "react";
import CoursesImage2 from "../Assets/Slide3/AboutImg.png";
import CoursesImage1 from "../Assets/Slide3/college.png";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import SummaryApi from "../common/index";
import { useNavigate } from "react-router-dom"; // for navigation
import CoursesImage7 from "../Assets/mission.png";
import CoursesImage8 from "../Assets/vission.png";
import { GiBullseye } from "react-icons/gi";
import { PiEyeBold } from "react-icons/pi";

const AboutArea = () => {
  const [currentText, setCurrentText] = useState(0);
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [texts, setTexts] = useState([]); // state for texts fetched from the API
  const [activeIndex, setActiveIndex] = useState(0);
  const [showAll, setShowAll] = useState(false);

  const faqData = [
    {
      question: "Vision",
      answer:
        "To create a collaborative academic environment to foster professional excellence and ethical values.",
      imgtag: <PiEyeBold />,
    },
    {
      question: "Mission",
      answer:
        "To impact high quality technical education in order to mould the learners into globally competitive technocrats who are professionally deft, intellectually adept and socially responsible.",
      imgtag: <GiBullseye />,
    },
  ];

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const itemsToDisplay = screenSize > 1440 ? 3 : screenSize >= 1024 ? 1 : 2;

  // Fetching texts from the API
  // Fetching texts from the API
  useEffect(() => {
    const fetchTexts = async () => {
      try {
        const response = await fetch(SummaryApi.getNews.url, {
          method: SummaryApi.getNews.method,
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (!response.ok) {
          throw new Error("Failed to fetch texts");
        }
        const data = await response.json();

        // Check if the response contains 'data' and it's an array
        if (Array.isArray(data.data)) {
          // Store both 'message' and 'news_id'
          const messageTexts = data.data.map((item) => ({
            message: item.message,
            news_id: item.news_id, // Store news_id as well
          }));
          setTexts(messageTexts); // Set both message and news_id in the state
        } else {
          console.error(
            "Fetched data is not an array or does not contain 'data'"
          );
        }
      } catch (error) {
        console.error("Error fetching texts:", error);
      }
    };

    fetchTexts(); // Call the API on mount
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentText((prev) => {
        if (prev + itemsToDisplay >= texts.length) {
          // If we're at the end, loop back to the first update
          return 0;
        }
        return prev + 1;
      });
    }, 4000); // Change interval as needed (currently 4 seconds for each update)

    return () => clearInterval(interval);
  }, [texts.length, itemsToDisplay]);

  const toggleAnswer = (index) => {
    setActiveIndex(index === activeIndex ? -1 : index);
  };

  const displayedFaqs = showAll ? faqData : faqData.slice(0, 5);
  const navigate = useNavigate();

  const handleViewMore = (newsId) => {
    navigate("/newsdetails", { state: { news_id: newsId } }); // Use news_id, not the index
  };

  return (
    <div style={{ padding: "5px 35px" }} className="mt-0">
      <h1 className="text-center text-2xl mt-5 font-bold">ABOUT</h1>
      <hr
        style={{
          border: "1px solid #D3D3D3 ",
          marginBottom: "15px",
          // width: "6%",
          // marginLeft: "47%",
        }}
        className="md:w-[6%] w-[28%] md:ml-[47%] ml-[36%]"
      />

      <div className="flex flex-col lg:flex-row w-full h-[500px]">
        <div className="w-full lg:w-1/2">
          <img
            src={CoursesImage1}
            alt="Course Image"
            className="w-full rounded-lg p-4 md:h-[680px] h-[450px]"
          />
        </div>

        <div className="w-full lg:w-1/2 flex flex-col h-full sm:space-y-8 md:space-y-8 lg:space-y-8 xl:space-y-4 2xl:space-y-8 mt-4">
          <div className="relative p-4 w-full bg-[#FF0000] text-white rounded-lg h-[500px] mb-2">
            <h1 className="text-4xl">News Updates</h1>
            <div className="text-lg space-y-3">
              {/* Check if texts is an array before calling slice */}
              {Array.isArray(texts) &&
                texts
                  .slice(currentText, currentText + itemsToDisplay)
                  .map((item, index) => (
                    <div key={index}>
                      <p
                        className="mb-0 p-0 sm:mb-1 md:mb-1 lg:mb-1 xl:mb-1 2xl:mb-1 sm:p-2 md:p-2 lg:p-2 xl:p-2 2xl:p-2 flex"
                        style={{
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          WebkitLineClamp: 2,
                          textOverflow: "ellipsis",
                          lineHeight: 1.8,
                        }}
                      >
                        {item.message}
                      </p>

                      <div className="flex justify-end mt-[-1%]">
                        <button
                          className=" text-white p-2 rounded-md hover:underline focus:outline-none focus:ring-2 focus:ring-blue-300 mb-1 text-[14px]"
                          onClick={() => handleViewMore(item.news_id)}
                        >
                          View More
                        </button>
                      </div>
                      <hr className="border-t-2 border-gray-300" />
                    </div>
                  ))}
            </div>
          </div>

          <div className="space-y-4 sm:mt-2">
            {displayedFaqs.map((item, index) => (
              <div
                key={index}
                className="border rounded-lg shadow-sm transition-transform "
              >
                <button
                  className={`w-full text-left px-4 py-3 font-medium text-lg sm:text-xl text-white flex justify-between items-center 
    ${
      item.question === "Vision"
        ? "bg-[#2C9CB5]"
        : item.question === "Mission"
        ? "bg-[#F39C12]"
        : "bg-[#3498DB]"
    }
  `}
                  onClick={() => toggleAnswer(index)}
                >
                  <span className="flex items-center text-xl font-Poly font-semibold">
                    <p className="mr-5">{item.imgtag}</p>
                    {item.question}
                  </span>

                  <span>
                    {activeIndex === index ? (
                      <IoIosArrowUp className="text-white" />
                    ) : (
                      <IoIosArrowDown className="text-white" />
                    )}
                  </span>
                </button>

                {activeIndex === index && (
                  <div className="px-4 py-3 text-gray-700 border-t text-[15px] font-Poly">
                    {item.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      <p className="font-Poly text-lg pt-[190%] sm:pt-[15%] md:pt-[89%] lg:pt-[15%] xl:pt-[9%] 2xl:pt-[15%] pb-10 text-justify leading-[1.8]">
        JPKP was established in 2013 by the Sri Jyothi Educational Society under
        Sri Venkata Ramana, who has over 40 years of majestic experience in the
        teaching field. JPKP offers a diploma in conventional and advanced
        branches for its students. JPKP has a strong line of experienced staff
        throughout its organizational structure. JPKP provides hostel facilities
        for both boys and girls, with a homely atmosphere. JPKP encourages its
        students to participate in both sports and cultural activities, in
        addition to their academic pursuits. As Chairman of our esteemed
        institution, it has been my honor to be a part of this great institute.
        In my time here, I have witnessed the hard work, dedication, and passion
        our students put into reaching the highest level of their academic life.
        Our efforts do not go unnoticed—many of our meritorious students are
        receiving well-deserved recognition for their achievements. As an
        institution, we continually strive to play a major role in the
        development of rural education, bringing out the best students through
        extensive training methodologies used by our expert trainers, all aimed
        at providing quality education. Through events like 'Motivate', we
        define ourselves as aspirational role models for every student, both in
        academics and career development outside of academics.
      </p>
    </div>
  );
};

export default AboutArea;
